import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasFurniture = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('has_furniture')(jsonQuery),
);
